
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogangapurcabs() {



    const cardData =
    {
        keyword: 'Pune to Gangapur Cabs',
        heading: 'Platinum24 Cabs: Pune to Gangapur Cabs',
        headingDescription: ' Platinum24 Cabs provides trusted Pune to Gangapur Cabs, ideal for devotees traveling to the sacred Dattatreya Temple and nearby pilgrimage spots. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe, comfortable, and air-conditioned ride for families and groups. With experienced chauffeurs familiar with the Pune–Gangapur route, we guarantee punctual pickups, convenient halts, and smooth highway travel. Whether it’s a one-way drop, round-trip, or a group pilgrimage yatra, Platinum24 Cabs offers affordable fares, transparent pricing, and reliable service to make your Pune to Gangapur journey peaceful and hassle-free.',

        top: 'Top Places to Visit in Gangapur with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shri Kshetra Ganagapur Dattatreya Temple",
    "description": "The Shri Kshetra Ganagapur Temple is the spiritual heart of the town, dedicated to Shri Narasimha Saraswati Swami, the second avatar of Lord Dattatreya. The temple houses his Nirgun Padukas (sacred sandals) in the main shrine. Devotees believe darshan here removes obstacles, grants peace, and fulfills wishes. The temple’s daily rituals include aartis, bhajans, and annadan seva. During Datta Jayanti, thousands of pilgrims gather to celebrate. It is Gangapur’s divine center of faith and devotion."
  },
  {
    "title": "Sangam Kshetra (Bhima–Amarja Sangam)",
    "description": "Sangam Kshetra is the confluence of the Bhima and Amarja rivers, considered one of the holiest places in Gangapur. Shri Narasimha Saraswati is believed to have meditated here. Pilgrims take ritual baths in the sacred waters, especially on Amavasya and Purnima, for purification. The place is surrounded by ghats and ancient trees, creating a serene spiritual environment. Devotees perform shraddha and pind daan rituals here. Sangam is Gangapur’s sacred riverbank of blessings."
  },
  {
    "title": "Kalleshwar Temple",
    "description": "Kalleshwar Temple is an ancient shrine dedicated to Lord Shiva, located near Gangapur. It is associated with legends of Shri Narasimha Saraswati’s divine presence. The temple’s Hemadpanthi architecture and peaceful surroundings attract devotees. It is a popular stop for pilgrims after visiting the main Dattatreya Temple. Rituals and aartis create a spiritual atmosphere. Kalleshwar Temple is Gangapur’s serene Shaiva pilgrimage spot."
  },
  {
    "title": "Audumbar Tree at Sangam",
    "description": "The Audumbar tree at Sangam Kshetra holds immense significance in the Datta Sampradaya. Devotees believe that meditating under the tree fulfills wishes and brings spiritual upliftment. Shri Narasimha Saraswati himself is said to have spent time here. Pilgrims tie sacred threads on the branches as a mark of devotion. The tree’s shade offers peace and calm to visitors. It is Gangapur’s living symbol of divine blessings."
  },
  {
    "title": "Bhasma Hill",
    "description": "Bhasma Hill near Gangapur is believed to be a place where Shri Narasimha Saraswati performed penance. The hill is surrounded by nature, offering panoramic views of the region. Pilgrims climb to the top for meditation and darshan of small shrines. Legends say saints attained moksha here. The trek is peaceful and spiritually rewarding. Bhasma Hill is Gangapur’s divine retreat of penance and meditation."
  },
  {
    "title": "Koti Teerth",
    "description": "Koti Teerth is a sacred tank located near the temple complex in Gangapur. Devotees take ritual dips here before visiting the Padukas of Shri Narasimha Saraswati. The waters are believed to have healing powers. Festivals like Datta Jayanti and Guru Purnima make the place vibrant with devotional activities. Pilgrims perform abhishekas and poojas here. Koti Teerth is Gangapur’s holy water body of purification and faith."
  },
  {
    "title": "Ganagapur Math",
    "description": "Ganagapur Math is an important spiritual institution preserving the teachings of Shri Narasimha Saraswati. It conducts daily bhajans, pravachans, and community meals for devotees. The math also supports education and service activities in the region. Pilgrims gather here to connect with saints and spiritual leaders. It reflects the living tradition of Datta Sampradaya. The math is Gangapur’s hub of spiritual knowledge and service."
  },
  {
    "title": "Bheema Amarja Ghats",
    "description": "The ghats at the confluence of Bhima and Amarja rivers are popular for devotional rituals. Pilgrims perform abhishek, pind daan, and tirtha snan here. The ghats are lively during Amavasya and Ekadashi. Devotional chants and conch sounds create a sacred ambiance. The riverbanks are also ideal for peaceful meditation. Bheema Amarja Ghats are Gangapur’s sacred waterfronts of devotion."
  },
  {
    "title": "Chintamani Ashram",
    "description": "Chintamani Ashram near Gangapur is a retreat for spiritual seekers and devotees of Lord Dattatreya. The ashram hosts satsangs, meditation sessions, and kirtans. It provides simple accommodation and meals for pilgrims. Surrounded by natural beauty, it is an ideal place for introspection. The ashram keeps alive the Datta Sampradaya’s message of service and devotion. Chintamani Ashram is Gangapur’s haven for peace and learning."
  },
  {
    "title": "Datta Jayanti Festival",
    "description": "Datta Jayanti is the biggest festival celebrated in Gangapur, marking the birth of Lord Dattatreya. Thousands of devotees arrive for special rituals, palkhi processions, and bhajans. The whole town is decorated with lights, flowers, and devotional flags. Annachhatras (community kitchens) feed pilgrims continuously. The festive energy is unforgettable and deeply spiritual. Datta Jayanti makes Gangapur the vibrant epicenter of the Datta tradition."
  }
],



       "services": [
    {
      "name": "Pune to Gangapur Cab Service",
      "description": "Dependable and comfortable cab services from Pune to Gangapur, ideal for pilgrims and tourists visiting local temples and scenic spots. Enjoy timely pickups, clean vehicles, and courteous drivers for a hassle-free journey."
    },
    {
      "name": "Gangapur Taxi from Pune",
      "description": "Affordable and reliable taxi options from Pune to Gangapur, including sedans and SUVs to accommodate solo travelers and groups alike. Experience smooth rides with professional drivers well-versed in local routes."
    },
    {
      "name": "Pune Gangapur Taxi Booking",
      "description": "Easily book your taxi from Pune to Gangapur through our convenient online system or customer support. Get instant confirmation, transparent pricing, and multiple vehicle choices tailored to your travel needs."
    },
    {
      "name": "Taxi for Gangapur Pilgrimage Pune",
      "description": "Special pilgrimage taxi services from Pune to Gangapur designed for devotees visiting temples and religious sites. Our drivers ensure timely arrivals and comfortable rides throughout your spiritual trip."
    },
    {
      "name": "Pune to Gangapur Car Rental",
      "description": "Flexible car rental options from Pune to Gangapur with choices for self-drive or chauffeur-driven vehicles. Ideal for travelers wanting to explore Gangapur and nearby areas at their own pace."
    },
    {
      "name": "Gangapur Taxi Packages Pune",
      "description": "Comprehensive taxi packages from Pune to Gangapur including fuel, tolls, and driver allowances. Choose from hourly, daily, or customized packages to suit your pilgrimage or sightseeing itinerary."
    },
    {
      "name": "Affordable Cab Pune to Gangapur",
      "description": "Budget-friendly cab services from Pune to Gangapur that combine comfort, reliability, and cost-efficiency, perfect for pilgrims and tourists seeking economical travel options."
    },
    {
      "name": "Pune Gangapur Private Taxi",
      "description": "Exclusive private taxi service from Pune to Gangapur offering privacy, flexible schedules, and personalized routes. Great for families, groups, or corporate travelers looking for tailored transportation."
    },
    {
      "name": "Pune to Gangapur Taxi Fare",
      "description": "Clear and competitive taxi fare details for trips between Pune and Gangapur, helping travelers plan their budget with transparent pricing and no hidden charges."
    },
    {
      "name": "Gangapur Cab Charges Pune",
      "description": "Detailed information on cab charges from Pune to Gangapur, including fuel costs, tolls, and driver allowances, enabling travelers to make informed travel decisions."
    },
    {
      "name": "Pune to Gangapur Taxi Hire",
      "description": "Flexible taxi hire services from Pune to Gangapur available for one-way trips or full-day excursions. Enjoy reliable vehicles and professional drivers to enhance your travel experience."
    },
    {
      "name": "Gangapur Temple Taxi Service Pune",
      "description": "Dedicated taxi services catering to pilgrims visiting temples in Gangapur, ensuring timely pickups, comfortable rides, and experienced drivers familiar with the pilgrimage routes."
    },
    {
      "name": "Pune to Gangapur One Way Cab",
      "description": "Affordable one-way taxi services from Pune to Gangapur for travelers who need point-to-point transportation without a return trip. Book easily with reliable service and transparent pricing."
    },
    {
      "name": "Pune Gangapur Taxi with Driver",
      "description": "Professional and courteous drivers accompany every taxi booking from Pune to Gangapur to ensure a safe, comfortable, and enjoyable journey. Drivers know the best routes and local insights."
    },
    {
      "name": "Taxi Service Pune to Gangapur",
      "description": "Comprehensive 24/7 taxi services from Pune to Gangapur suitable for pilgrimage, tourism, and local transportation needs. Expect punctual pickups, clean vehicles, and excellent customer service."
    }
  ],
  "tableData": [
    ["Pune to Gangapur Cab Service", "Gangapur Taxi from Pune"],
    ["Pune Gangapur Taxi Booking", "Taxi for Gangapur Pilgrimage Pune"],
    ["Pune to Gangapur Car Rental", "Gangapur Taxi Packages Pune"],
    ["Affordable Cab Pune to Gangapur", "Pune Gangapur Private Taxi"],
    ["Pune to Gangapur Taxi Fare", "Gangapur Cab Charges Pune"],
    ["Pune to Gangapur Taxi Hire", "Gangapur Temple Taxi Service Pune"],
    ["Pune to Gangapur One Way Cab", "Pune Gangapur Taxi with Driver"],
    ["Taxi Service Pune to Gangapur", "—"]
  ],


          "whychoose": [
    {
      "WhyChooseheading": "Dependable Pune to Gangapur Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable rides from Pune to Gangapur for a hassle-free journey."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune-Gangapur Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes to ensure safe and timely travel."
    },
    {
      "WhyChooseheading": "Clean and Spacious Vehicles for Long-Distance Travel",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed for maximum comfort."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose from packages that suit your travel plans and schedule."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
      "WhyChoosedescription": "Enjoy upfront pricing that covers fuel, tolls, and driver allowances for stress-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Our support team is available round the clock to assist with your bookings and queries."
    },
    {
      "WhyChooseheading": "Ideal for Families, Groups, and Business Travelers",
      "WhyChoosedescription": "Our cabs cater to all types of travelers and group sizes."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Meet Your Needs",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, and more based on your group and luggage requirements."
    }
  ]


































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Gangapur?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel between Pune and Gangapur.',
    },
    {
        question: 'How can I book a Pune to Gangapur cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Gangapur cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Gangapur trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Gangapur?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Gangapur route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Gangapur?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Gangapur cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Gangapur rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Gangapur route.',
    },
    {
        question: 'Are safety measures in place for Pune to Gangapur cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Gangapur travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Gangapur?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Gangapur routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajay More',
        feedback: 'The Pune to Gangapur cab service by Platinum24 Cabs was prompt and the driver was very professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Pooja Shinde',
        feedback: 'I enjoyed a hassle-free trip to Gangapur with Platinum24 Cabs. The booking was quick and the ride was comfortable.',
        rating: 5,
    },
];











































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];





const puneToGangapurCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Gangapur Cab",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-gangapur-cab.jpg",
  "description": "Book Pune to Gangapur cab service with Platinum24 Cabs. Comfortable AC taxis and car rentals available for Shri Guru Dattatreya pilgrimage. One-way, round trip, and group cab options with verified drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3599",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-gangapur-cab"
  }
};










    return (
        <div>
<Helmet>
  <title>Pune to Gangapur Cab | Shri Dattatreya Mandir Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Hire Pune to Gangapur cab with Platinum24 Cabs. AC taxis and private cars for Guru Dattatreya Mandir darshan. Book one-way or round trip rides with professional drivers."
  />
  <meta
    name="keywords"
    content="Pune to Gangapur Cab Service, Gangapur Taxi from Pune, Pune Gangapur Taxi Booking, Taxi for Gangapur Pilgrimage Pune, Pune to Gangapur Car Rental, Gangapur Taxi Packages Pune, Affordable Cab Pune to Gangapur, Pune Gangapur Private Taxi, Pune to Gangapur Taxi Fare, Gangapur Cab Charges Pune, Pune to Gangapur Taxi Hire, Gangapur Temple Taxi Service Pune, Pune to Gangapur One Way Cab, Pune Gangapur Taxi with Driver, Taxi Service Pune to Gangapur"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToGangapurCabsSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogangapurcabs;